import React from 'react'
import { ScrollView } from "react-native"

export const KeyboardAwareScrollView = ({ children, ...props }: any) => {
  return <ScrollView {...props}>{children}</ScrollView>
}

export default KeyboardAwareScrollView
